"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _FormInput = _interopRequireDefault(require("../Forms/FormInput"));

var _InputGroup = _interopRequireDefault(require("../InputGroup/InputGroup"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _react = _interopRequireWildcard(require("react"));

var _inputGroup = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/input-group.css") : void 0);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _inputGroup.default);

var TimePickerItem = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TimePickerItem, _Component);

  var _super = _createSuper(TimePickerItem);

  function TimePickerItem(_props) {
    var _this;

    (0, _classCallCheck2.default)(this, TimePickerItem);
    _this = _super.call(this, _props);

    _this.setLength = function (props) {
      var length = 0;

      if (props.format12Hours && props.showHour && props.showMinute && props.showSecond) {
        //format hh:mm:ss am
        length = 11;
      } else if (!props.format12Hours && props.showHour && props.showMinute && props.showSecond) {
        //format hh:mm:ss
        length = 8;
      } else if (!props.format12Hours && props.showHour && props.showMinute || !props.format12Hours && props.showMinute && props.showSecond) {
        //format hh:mm
        length = 5;
      } else if (props.format12Hours && props.showHour && props.showMinute || props.format12Hours && props.showMinute && props.showSecond) {
        //format hh:mm am
        length = 8;
      }

      return length;
    };

    _this.onChange = function (event) {
      event.stopPropagation();

      _this.setState({
        value: event.target.value
      });

      var aux = event.target.value;

      _this.onInputValidation(aux, event);

      _this.props.updateValue(aux);
    };

    _this.onInputValidation = function (value, event) {
      var _this$props = _this.props,
          showHour = _this$props.showHour,
          showMinute = _this$props.showMinute,
          showSecond = _this$props.showSecond,
          format12Hours = _this$props.format12Hours;

      if (format12Hours && showHour && showMinute && showSecond) {
        //validate hh:mm:ss am/pm format
        var regex = new RegExp('^(1[0-2]|0?[1-9]):([0-5]?[0-9]):([0-5]?[0-9]) ([AaPp][Mm])$');
        return _this.inputCheck(regex, value, event);
      } else if (!format12Hours && showHour && showMinute && showSecond) {
        //validate hh:mm:ss format
        var _regex = new RegExp('^(2[0-3]|[01]?[0-9]):([0-5]?[0-9]):([0-5]?[0-9])$');

        return _this.inputCheck(_regex, value, event);
      } else if (format12Hours && showHour && showMinute) {
        //validate hh:mm am
        var _regex2 = new RegExp('^(1[0-2]|0?[1-9]):([0-5]?[0-9]) ([AaPp][Mm])$');

        return _this.inputCheck(_regex2, value, event);
      } else if (!format12Hours && showHour && showMinute) {
        //validate hh:mm
        var _regex3 = new RegExp('^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$');

        return _this.inputCheck(_regex3, value, event);
      } else if (format12Hours && showMinute && showSecond) {
        //validate mm:ss am
        var _regex4 = new RegExp('^([0-5]?[0-9]):([0-5]?[0-9]) ([AaPp][Mm])$');

        return _this.inputCheck(_regex4, value, event);
      } else if (!format12Hours && showMinute && showSecond) {
        //validate mm:ss
        var _regex5 = new RegExp('^([0-5]?[0-9]):([0-5]?[0-9])$');

        return _this.inputCheck(_regex5, value, event);
      }
    };

    _this.inputCheck = function (regex, value, event) {
      if (regex.test(value) && value.length === _this.state.length) {
        if (event.type === 'blur') {
          return true;
        }

        _this.setState({
          isValid: true,
          style: classnames("".concat(_this.props.cssNamespace, "-input-group__input"))
        }); //send time value to Time Component


        _this.updateTime(value);
      } else {
        if (event.type === 'blur') {
          return false;
        }

        _this.setState({
          isValid: false,
          style: classnames('is-invalid')
        });
      }
    };

    _this.updateTime = function (value) {
      var length = _this.state.length;
      var _this$props2 = _this.props,
          showHour = _this$props2.showHour,
          showMinute = _this$props2.showMinute,
          showSecond = _this$props2.showSecond,
          format12Hours = _this$props2.format12Hours;

      if (length === 11) {
        // this means the time format is hh:mm:ss am convert string into corresponding
        // time format
        var timeValues = value.split(' ');

        if (timeValues.length === 2) {
          var _context;

          var timeValue = timeValues[0].split(':');
          var time = {
            hour: timeValue[0],
            minute: timeValue[1],
            second: timeValue[2],
            meridiem: (0, _indexOf.default)(_context = _this.CLOCK).call(_context, timeValues[1])
          };

          _this.props.onChange(time);
        }
      } else if (length === 5) {
        //format hh:mm or mm:ss
        if (showHour && showMinute && !showSecond) {
          _this.updateTimeHHMM(value);
        } else if (!showHour && showMinute && showSecond) {
          _this.updateTimeMMSS(value);
        }
      } else if (length === 8) {
        if (format12Hours) {
          if (showHour && showMinute && !showSecond) {
            //hh:mm am
            _this.updateTimeHHMMAM(value);
          } else if (!showHour && showMinute && showSecond) {
            //hh:mm am
            _this.updateTimeMMSSAM(value);
          }
        } else {
          //hh:mm:ss
          _this.updateTimeHHMMSS(value);
        }
      }
    };

    _this.updateTimeHHMMSS = function (value) {
      var timeValues = value.split(':');

      if (timeValues.length === 3) {
        var time = {
          hour: timeValues[0],
          minute: timeValues[1],
          second: timeValues[2]
        };

        _this.props.onChange(time);
      }
    };

    _this.updateTimeHHMM = function (value) {
      var timeValues = value.split(':');

      if (timeValues.length === 2) {
        var time = {
          hour: timeValues[0],
          minute: timeValues[1]
        };

        _this.props.onChange(time);
      }
    };

    _this.updateTimeMMSS = function (value) {
      var timeValues = value.split(':');

      if (timeValues.length === 2) {
        var time = {
          minute: timeValues[0],
          second: timeValues[1]
        };

        _this.props.onChange(time);
      }
    };

    _this.updateTimeHHMMAM = function (value) {
      var timeValues = value.split(' ');

      if (timeValues.length === 2) {
        var _context2;

        var timeValue = timeValues[0].split(':');
        var time = {
          hour: timeValue[0],
          minute: timeValue[1],
          meridiem: (0, _indexOf.default)(_context2 = _this.CLOCK).call(_context2, timeValues[1])
        };

        _this.props.onChange(time);
      }
    };

    _this.updateTimeMMSSAM = function (value) {
      var timeValues = value.split(' ');

      if (timeValues.length === 2) {
        var _context3;

        var timeValue = timeValues[0].split(':');
        var time = {
          minute: timeValue[0],
          second: timeValue[1],
          meridiem: (0, _indexOf.default)(_context3 = _this.CLOCK).call(_context3, timeValues[1])
        };

        _this.props.onChange(time);
      }
    };

    _this.onBlur = function (event) {
      //if the input is not the correct format then  it will be cleared
      if (!_this.onInputValidation(event.target.value, event)) {
        _this.props.updateValue('');
      } //reset to initial style


      _this.setState({
        style: classnames("".concat(_this.props.cssNamespace, "-input-group__input"))
      });
    };

    var _length = _this.setLength(_props);

    _this.CLOCK = [_this.props.localizedText.meridiemAM, _this.props.localizedText.meridiemPM];
    _this.state = {
      value: _this.props.value,
      inputId: _this.props.id && _this.props.id + '-input',
      buttonID: _this.props.id && _this.props.id + '-button',
      style: '',
      isValid: false,
      length: _length
    };
    return _this;
  }

  (0, _createClass2.default)(TimePickerItem, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          disabled = _this$props3.disabled,
          inputProps = _this$props3.inputProps,
          buttonProps = _this$props3.buttonProps,
          onClick = _this$props3.onClick;
      return /*#__PURE__*/_react.default.createElement(_InputGroup.default, {
        onClick: onClick
      }, /*#__PURE__*/_react.default.createElement(_FormInput.default, (0, _extends2.default)({}, inputProps, {
        className: this.state.style,
        id: this.state.inputId,
        onBlur: this.onBlur,
        onChange: this.onChange,
        onFocus: this.onFocus,
        placeholder: this.props.placeholder,
        readOnly: disabled,
        value: this.props.value
      })), /*#__PURE__*/_react.default.createElement(_InputGroup.default.Addon, {
        isButton: true
      }, /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, buttonProps, {
        "aria-controls": "rthHR811",
        "aria-expanded": "false",
        "aria-haspopup": "true",
        compact: true,
        disabled: disabled,
        glyph: "time-entry-request",
        id: this.state.buttonID,
        option: "transparent"
      }))));
    }
  }]);
  return TimePickerItem;
}(_react.Component);

TimePickerItem.displayName = 'TimePickerItem';
process.env.NODE_ENV !== "production" ? TimePickerItem.propTypes = {
  localizedText: _propTypes.default.object.isRequired,
  buttonId: _propTypes.default.string,

  /** Additional props to be spread to the `<button>` element */
  buttonProps: _propTypes.default.object,

  /** Set to **true** to mark component as disabled and make it non-interactive */
  disabled: _propTypes.default.bool,
  format12Hours: _propTypes.default.bool,

  /** Value for the `id` attribute on the element */
  id: _propTypes.default.string,
  inputId: _propTypes.default.string,

  /** Additional props to be spread to the `<input>` element */
  inputProps: _propTypes.default.object,
  isValid: _propTypes.default.bool,
  length: _propTypes.default.number,

  /** Localized placeholder text of the input */
  placeholder: _propTypes.default.string,
  showHour: _propTypes.default.bool,
  showMinute: _propTypes.default.bool,
  showSecond: _propTypes.default.bool,
  style: _propTypes.default.string,
  updateValue: _propTypes.default.func,
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /** Callback function when the change event fires on the component */
  onChange: _propTypes.default.func,

  /** Callback function when user clicks on the component*/
  onClick: _propTypes.default.func
} : void 0;

var _default = (0, _withStyles.default)(TimePickerItem);

exports.default = _default;